import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@oasisprotocol/ui-library/src/components/ui/button'
import { Pen } from 'lucide-react'
import { Network } from '../../../types/network'
import { Layer } from '../../../oasis-nexus/api'
import { LayerStatus } from '../LayerStatus'
import { getNameForScope } from '../../../types/searchScope'
import { TFunction } from 'i18next'

type NetworkButtonProps = {
  isOutOfDate?: boolean
  layer: Layer
  network: Network
  onClick: () => void
}

const getNetworkButtonLabel = (t: TFunction, network: Network, layer: Layer) =>
  getNameForScope(t, { network, layer })

export const NetworkButton: FC<NetworkButtonProps> = ({ isOutOfDate, layer, network, onClick }) => {
  const { t } = useTranslation()

  return (
    <Button
      variant="outline"
      size="lg"
      onClick={onClick}
      className="flex justify-between items-center w-[223px] p-0 border-1 rounded-md text-left overflow-hidden
shadow-none gap-0
  focus-visible:ring-0 z-20"
    >
      <div className="flex w-full items-center justify-between gap-2 px-4">
        {getNetworkButtonLabel(t, network, layer)}
        <LayerStatus isOutOfDate={isOutOfDate} />
      </div>

      <div className="flex items-center justify-center h-10 px-4 border-l rounded-r-md">
        <Pen className="text-primary w-4 h-4" />
      </div>
    </Button>
  )
}

export const MobileNetworkButton: FC<NetworkButtonProps> = ({ isOutOfDate, layer, network, onClick }) => {
  const { t } = useTranslation()

  return (
    <Button
      variant="outline"
      onClick={onClick}
      className="flex items-center gap-3 h-[30px] px-4 rounded-md font-medium shadow-none"
    >
      {getNetworkButtonLabel(t, network, layer)}
      <LayerStatus isOutOfDate={isOutOfDate} />
    </Button>
  )
}
